export default __webpack_public_path__ + "static/0202-b59d81ae33cb5ee36d82cdfd732bb3c0.png";